/* Royal Fans — custom quick-view modal. Fully self-contained: no theme/Dawn modal, no app.
   Renders from /products/<handle>.js, handles variant selection + qty + add-to-cart (/cart/add.js)
   with a success state. Responsive (desktop dialog / mobile bottom-sheet). */
(function () {
  function money(cents) {
    return 'Rs.' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  if (!customElements.get('rf-quick-add')) {
    customElements.define('rf-quick-add', class extends HTMLElement {
      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        this.bodyEl = this.querySelector('[data-rf-qa-body]');
        this.addEventListener('click', (e) => { if (e.target === this) this.close(); });
        this.querySelectorAll('[data-rf-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this._esc = (e) => { if (e.key === 'Escape') this.close(); };
        // Hoist to <body> so the fixed modal escapes the card :hover transform / carousel overflow.
        document.body.appendChild(this);
      }
      open(opener) {
        this.opener = opener;
        this.url = (opener.getAttribute('data-product-url') || '').split('?')[0];
        this.bodyEl.innerHTML = '<div class="rf-qa__spin"></div>';
        this.setAttribute('open', '');
        document.body.classList.add('rf-qa-open');
        document.addEventListener('keyup', this._esc);
        fetch(this.url + '.js')
          .then((r) => r.json())
          .then((p) => this.render(p))
          .catch(() => { this.bodyEl.innerHTML = '<div style="padding:48px;text-align:center;color:#002B44">Couldn\'t load this product. <a href="' + this.url + '">View product &rarr;</a></div>'; });
      }
      close() {
        this.removeAttribute('open');
        document.body.classList.remove('rf-qa-open');
        document.removeEventListener('keyup', this._esc);
        this.bodyEl.innerHTML = '';
        if (this.opener && this.opener.focus) { try { this.opener.focus(); } catch (e) {} }
      }
      render(p) {
        this.product = p;
        // /products/<handle>.js may return options as strings OR objects ({name, values}).
        this.optNames = (p.options || []).map(function (o) { return (o && typeof o === 'object') ? o.name : o; });
        // No reliable has_only_default_variant flag on this store → detect the default single variant.
        this.noOptions = p.variants.length === 1 && p.variants[0].title === 'Default Title';
        var initV = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        this.selected = initV.options.slice();
        this.qty = 1;
        var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);
        this.images = imgs;
        var thumbs = imgs.length > 1
          ? '<div class="rf-qa__thumbs">' + imgs.slice(0, 6).map(function (src, i) {
              return '<button type="button" class="rf-qa__thumb' + (i === 0 ? ' is-active' : '') + '" data-rf-thumb="' + src + '"><img src="' + src + '" alt="" loading="lazy"></button>';
            }).join('') + '</div>'
          : '';
        this.bodyEl.innerHTML =
          '<div class="rf-qa__grid">' +
            '<div class="rf-qa__media">' +
              '<div class="rf-qa__main"><img data-rf-main src="' + (imgs[0] || '') + '" alt="' + esc(p.title) + '"></div>' +
              thumbs +
            '</div>' +
            '<div class="rf-qa__details">' +
              '<h3 class="rf-qa__title">' + esc(p.title) + '</h3>' +
              '<div class="rf-qa__price" data-rf-price></div>' +
              '<div data-rf-options></div>' +
              '<div class="rf-qa__qtyrow"><span class="rf-qa__qtyrow-label">Qty</span>' +
                '<div class="rf-qa__qty"><button type="button" data-rf-qm aria-label="Decrease">&minus;</button>' +
                '<input type="number" min="1" value="1" data-rf-qty aria-label="Quantity">' +
                '<button type="button" data-rf-qp aria-label="Increase">+</button></div></div>' +
              '<button type="button" class="rf-qa__atc" data-rf-atc><span data-rf-atc-text>Add to cart</span><span class="rf-qa__btnspin"></span></button>' +
              '<div class="rf-qa__err" data-rf-err></div>' +
              '<a class="rf-qa__view" href="' + this.url + '">View full details &rarr;</a>' +
            '</div>' +
          '</div>';
        this.renderOptions();
        this.update();
        var self = this;
        this.bodyEl.querySelectorAll('[data-rf-thumb]').forEach(function (t) {
          t.addEventListener('click', function () {
            self.bodyEl.querySelector('[data-rf-main]').src = t.getAttribute('data-rf-thumb');
            self.bodyEl.querySelectorAll('[data-rf-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
            t.classList.add('is-active');
          });
        });
        this.bodyEl.querySelector('[data-rf-qm]').addEventListener('click', function () { self.setQty(self.qty - 1); });
        this.bodyEl.querySelector('[data-rf-qp]').addEventListener('click', function () { self.setQty(self.qty + 1); });
        this.bodyEl.querySelector('[data-rf-qty]').addEventListener('change', function (e) { self.setQty(parseInt(e.target.value, 10) || 1); });
        this.bodyEl.querySelector('[data-rf-atc]').addEventListener('click', function () { self.addToCart(); });
      }
      renderOptions() {
        var self = this, p = this.product, box = this.bodyEl.querySelector('[data-rf-options]');
        if (this.noOptions) { box.innerHTML = ''; return; }
        box.innerHTML = this.optNames.map(function (name, i) {
          var vals = [];
          p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
          return '<div class="rf-qa__opt"><span class="rf-qa__opt-label">' + esc(name) + '</span><div class="rf-qa__values">' +
            vals.map(function (val) { return '<button type="button" class="rf-qa__pill" data-rf-optidx="' + i + '" data-rf-optval="' + esc(val) + '">' + esc(val) + '</button>'; }).join('') +
            '</div></div>';
        }).join('');
        box.querySelectorAll('[data-rf-optidx]').forEach(function (b) {
          b.addEventListener('click', function () {
            self.selected[parseInt(b.getAttribute('data-rf-optidx'), 10)] = b.getAttribute('data-rf-optval');
            self.update();
          });
        });
      }
      currentVariant() {
        var sel = this.selected;
        return this.product.variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        })[0] || null;
      }
      update() {
        var p = this.product, v = this.currentVariant(), self = this;
        this.bodyEl.querySelectorAll('[data-rf-optidx]').forEach(function (b) {
          var i = parseInt(b.getAttribute('data-rf-optidx'), 10), val = b.getAttribute('data-rf-optval');
          b.classList.toggle('is-active', self.selected[i] === val);
          var possible = p.variants.some(function (vr) {
            return vr.options[i] === val && vr.available && vr.options.every(function (o, j) { return j === i || o === self.selected[j]; });
          });
          b.classList.toggle('is-soldout', !possible);
        });
        var priceEl = this.bodyEl.querySelector('[data-rf-price]');
        if (v) {
          var html = '<span class="rf-qa__price-now">' + money(v.price) + '</span>';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html += '<span class="rf-qa__price-was">' + money(v.compare_at_price) + '</span>';
            html += '<span class="rf-qa__price-save">Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%</span>';
          }
          priceEl.innerHTML = html;
          if (v.featured_image && v.featured_image.src) {
            var m = this.bodyEl.querySelector('[data-rf-main]'); if (m) m.src = v.featured_image.src;
          }
        }
        var atc = this.bodyEl.querySelector('[data-rf-atc]'), txt = this.bodyEl.querySelector('[data-rf-atc-text]');
        if (!v) { atc.disabled = true; txt.textContent = 'Unavailable'; }
        else if (!v.available) { atc.disabled = true; txt.textContent = 'Sold out'; }
        else { atc.disabled = false; txt.textContent = 'Add to cart'; }
      }
      setQty(q) { if (q < 1) q = 1; this.qty = q; var i = this.bodyEl.querySelector('[data-rf-qty]'); if (i) i.value = q; }
      addToCart() {
        var v = this.currentVariant(); if (!v || !v.available) return;
        var atc = this.bodyEl.querySelector('[data-rf-atc]'), err = this.bodyEl.querySelector('[data-rf-err]'), self = this;
        atc.classList.add('is-loading'); atc.disabled = true; err.textContent = '';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: self.qty }] })
        })
          .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
          .then(function () { self.updateCartCount(); self.showSuccess(); })
          .catch(function (e) { err.textContent = (e && e.description) || 'Could not add to cart.'; atc.classList.remove('is-loading'); atc.disabled = false; });
      }
      updateCartCount() {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('.cart-count,.cart-count-bubble,.header__cart-count,.ap-cart-count,.cart-link__bubble,[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('rf:cart:updated', { detail: c }));
        }).catch(function () {});
      }
      showSuccess() {
        this.bodyEl.innerHTML =
          '<div class="rf-qa__success">' +
            '<span class="rf-qa__success-check"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l4 4 10-10"/></svg></span>' +
            '<h3>Added to cart</h3>' +
            '<p>' + esc(this.product.title) + '</p>' +
            '<div class="rf-qa__success-actions"><a class="rf-qa__sa-cart" href="/cart">View cart</a><a class="rf-qa__sa-checkout" href="/checkout">Checkout</a></div>' +
            '<button type="button" class="rf-qa__continue" data-rf-close>Continue shopping</button>' +
          '</div>';
        var self = this;
        this.bodyEl.querySelectorAll('[data-rf-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      }
    });
  }
  if (!window.__rfQaDelegate) {
    window.__rfQaDelegate = true;
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-rf-qa-open]');
      if (!o) return;
      e.preventDefault();
      var m = document.querySelector(o.getAttribute('data-rf-qa-open'));
      if (m && typeof m.open === 'function') m.open(o);
    });
  }
})();
